const client = require('contentful').createClient({
  space: "hzzwwgmfwaxb",
  accessToken: "Flb8oGahe1WxzStUkIKDKfD2pmAOHs8b2XVgrGfSUzc"
})

const getSinglePageIntro = page => client.getEntries({
    'fields.title': page,
    content_type: 'homepage'
  })
  .then(response => response.items)

  const getHomePanels = () => client.getEntries({
    content_type: "homepageTiles",
    order:"fields.order"
  }).then(response => response.items)

  const getWhySiso = () => client.getEntries({
    content_type: "why",
    order:"fields.order"
  }).then(response => response.items)

  const getAboutPanels = () => client.getEntries({
    content_type: "aboutTiles",
    order:"fields.order"
  }).then(response => response.items)

  const getClientPanels = () => client.getEntries({
    content_type: "clients",
    order:"fields.order"
  }).then(response => response.items)

  const getDisplayServices = page => client.getEntries({
      'fields.area': page,
      content_type: 'specificService',
      order:"fields.order"
    })
    .then(response => response.items)

    // const getMultipleSummaries = tag =>
    //   client
    //   .getEntries({
    //     'fields.tags': tag,
    //     content_type: 'blogPost',
    //     select: 'fields.title,fields.summary,fields.publishedDate,fields.tags,fields.rollUpImage,fields.slug'
    //   })
    //   .then(response => response.items)

export { getSinglePageIntro, getHomePanels, getWhySiso, getAboutPanels, getClientPanels, getDisplayServices }
